import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import LeftPanelCollapsed from './LeftPanelCollapsed';
import LeftPanelExpanded from './LeftPanelExpanded';
import handleKeyPress from '../../common/handleKeyPress';
import imageSources from '../../constants/imageSources/imageSources';

export default class LeftPanel extends Component {
    state = {
        mouseOverLeftPanel: false,
        mouseOverCollapseExpandLeftPanel: false,
    };

    render() {
        const { mouseOverLeftPanel, mouseOverCollapseExpandLeftPanel } = this.state;
        const { shouldLeftPanelBeCollapsed, leftPanelCollapsed, leftPanelWidth, setUserCollapsePreference } =
            this.props;

        return (
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            <div
                style={{
                    width: leftPanelWidth,
                    transition: 'width 0.7s',
                    height: '100%',
                    backgroundColor: 'white',
                    position: 'relative',
                    userSelect: 'none',
                }}
                onMouseOver={() => this.setState({ mouseOverLeftPanel: true })}
                onMouseLeave={() => this.setState({ mouseOverLeftPanel: false })}
            >
                {!shouldLeftPanelBeCollapsed && mouseOverLeftPanel && (
                    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                    <div
                        data-tip
                        data-for="collapseExpandLeftPanel"
                        style={{
                            position: 'absolute',
                            width: 32,
                            height: 32,
                            top: 'calc(50% - 14px)',
                            right: -16,
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            boxShadow: '0px 2px 3px 1px lightgrey',
                            cursor: 'pointer',
                            zIndex: 2,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            border: '1px solid #D9DADB',
                        }}
                        onMouseOver={() => this.setState({ mouseOverCollapseExpandLeftPanel: true })}
                        onMouseLeave={() => this.setState({ mouseOverCollapseExpandLeftPanel: false })}
                        onClick={() => setUserCollapsePreference(!leftPanelCollapsed)}
                        onKeyDown={(e) => handleKeyPress(e, () => setUserCollapsePreference(!leftPanelCollapsed))}
                        tabIndex={0}
                        role="button"
                        aria-label={`${leftPanelCollapsed ? 'Expand' : 'Collapse'} left sidebar`}
                    >
                        {leftPanelCollapsed ? (
                            <div
                                style={{
                                    width: 24,
                                    height: 24,
                                    transform: 'rotate(0deg)',
                                    transition: 'transform 0.40s ease-out',
                                    backgroundImage: `url(${
                                        mouseOverCollapseExpandLeftPanel
                                            ? imageSources.ICONS.ARROW_RIGHT
                                            : imageSources.ICONS.CHEVRON_RIGHT
                                    })`,
                                    backgroundPosition: mouseOverCollapseExpandLeftPanel ? 'center' : 'right',
                                    backgroundRepeat: 'no-repeat',
                                }}
                            />
                        ) : (
                            <div
                                style={{
                                    width: 24,
                                    height: 24,
                                    transform: 'rotate(180deg)',
                                    transition: 'transform 0.40s ease-out',
                                    backgroundImage: `url(${
                                        mouseOverCollapseExpandLeftPanel
                                            ? imageSources.ICONS.ARROW_RIGHT
                                            : imageSources.ICONS.CHEVRON_RIGHT
                                    })`,
                                    backgroundPosition: mouseOverCollapseExpandLeftPanel ? 'center' : 'right',
                                    backgroundRepeat: 'no-repeat',
                                }}
                            />
                        )}
                        <ReactTooltip id="collapseExpandLeftPanel" effect="solid" place="right" aria-hidden>
                            <span style={{ fontWeight: 'bold' }}>
                                {leftPanelCollapsed ? 'Expand Sidebar' : 'Collapse sidebar'}
                            </span>
                        </ReactTooltip>
                    </div>
                )}
                {leftPanelCollapsed ? (
                    <LeftPanelCollapsed leftPanelCollapsed={leftPanelCollapsed} />
                ) : (
                    <LeftPanelExpanded />
                )}
            </div>
        );
    }
}

LeftPanel.propTypes = {
    shouldLeftPanelBeCollapsed: PropTypes.bool.isRequired,
    leftPanelCollapsed: PropTypes.bool.isRequired,
    leftPanelWidth: PropTypes.number.isRequired,
    setUserCollapsePreference: PropTypes.func.isRequired,
};
